import { slice } from './slice'

const afaCartOutOfAssortmentActions = {
  ...slice.actions,
}

export default afaCartOutOfAssortmentActions
